import React from "react";

import logo1 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/brightspring-logo.svg";
import logo2 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/methodist-logo.webp";
import logo3 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/hca-logo.svg";
import logo4 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/well-path-logo.webp";
import logo5 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/Rockaway-Home-Care-Logo.jpg";
import logo6 from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/christian-horizons-logo-1.webp";

import reportImg from "../../../assets/EMP_hospitalhealthcare/HealthcareTrusted/financial-wellness-benefits-cover.webp";

export default function HealthcareTrusted() {
  return (
    <>
    <section className="w-full bg-white pt-24">

      {/* Heading */}
      <h1 className="text-center text-[15px] lg:text-[18px] font-extrabold text-black tracking-normal">
        TRUSTED BY HEALTHCARE LEADERS
      </h1>

      {/* Logos */}
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-8 lg:gap-14 py-12 px-6">
        
        <img
          src={logo1}
          alt=""
          className="w-[120px] lg:w-[150px] object-contain"
        />

        <img
          src={logo2}
          alt=""
          className="w-[120px] lg:w-[160px] object-contain"
        />

        <img
          src={logo3}
          alt=""
          className="w-[120px] lg:w-[160px] h-[40px] lg:h-[50px] object-contain"
        />

        <img
          src={logo4}
          alt=""
          className="w-[80px] lg:w-[110px] h-[40px] lg:h-[50px] object-contain"
        />

        <img
          src={logo5}
          alt=""
          className="w-[80px] lg:w-[100px] h-[40px] lg:h-[50px] object-contain"
        />

       <img
  src={logo6}
  alt=""
  className="w-[120px] lg:w-[150px] h-[40px] lg:h-[45px] object-contain"
/>
      </div>

      {/* Bottom Banner */}
      <div className="w-screen bg-[#dfe3f3] relative mt-8 left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">

        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between px-6 lg:px-20 h-[90px] relative">

          {/* Left Image */}
          <div className="absolute left-[180px] -top-[40px] hidden lg:block">
            <img
              src={reportImg}
              alt=""
              className="w-[190px] object-contain"
            />
          </div>

          {/* Mobile Image */}
          <div className="lg:hidden -mt-16 mb-4">
            <img
              src={reportImg}
              alt=""
              className="w-[150px] object-contain"
            />
          </div>

          {/* Text */}
          <h3 className="text-[18px] lg:text-[24px] font-bold text-[#1a0606] text-center lg:ml-[300px] tracking-tighter">
            We Are the #1 Most Adopted Financial Wellness Benefit
          </h3>

          {/* Button */}
          <button className=" lg:mr-[200px] mt-4 lg:mt-0 border border-[#2b0000] px-5 py-2 text-[#2b0000] text-base hover:bg-[#d7c27d] hover:text-[#2b0000] transition">
            Learn More
          </button>

        </div>
      </div>
    </section>

{/* BENEFITS FOR HOSPITALS, CLINICS & HEALTHCARE SERVICES */}

    <section className="w-full bg-white py-24 lg:py-36 px-6">

  <div className="max-w-5xl mx-auto text-center">

    {/* Top Small Heading */}
    <p className="text-[#ad3300] text-[15px] lg:text-[15px] font-bold tracking-[1px] uppercase">
      BENEFITS FOR HOSPITALS, CLINICS & HEALTHCARE SERVICES
    </p>

    {/* Main Heading */}
    <h1 className="mt-6 text-[#2b0000] text-5xl lg:text-5xl leading-tight">
      How Can On-Demand Pay Help <br />
      the Healthcare Industry?
    </h1>

    {/* Description */}
    <p className="mt-8 text-[#2b0000] text-xl lg:text-[16px] font-poppins leading-relaxed">
      When employees aren’t stressed over their finances, <br />
      they bring their best selves to work.
    </p>

    {/* Button */}
    <button className="mt-10 bg-[#2b0000] text-white px-10 py-4 text-[18px] font-semibold hover:bg-[#3b0000] transition">
      Book a Demo
    </button>

  </div>

</section>
    </>
  );
}